/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {ModalEl} from 'common/components/modal';
import {ButtonEl} from 'common/components/button';
import {ButtonSize, ButtonTheme} from 'common/components/button/constants';

/*
  We show this modal to enterprise customers who visit the plan builder
  in order to prevent them from interacting with the plan builder and 
  guide them to our contact sales page.
*/

export const EnterpriseModal = (isOpen, trackContactSalesClicked) => {
  return (
    <ModalEl
      attrs={{
        open: isOpen,
        closeable: false,
      }}
      sel='.modal-wrapper'
    >
      <div sel='.modal-content'>
        <div sel='.modal-title'>Contact sales to edit your Enterprise plan</div>
        <div sel='.modal-body'>
          We've found that Enterprise plans often require customization for your needs, and are better served with a
          human touch. Get in touch to renew or edit your Enterprise plan.
        </div>
        <div sel='.buttons'>
          <ButtonEl
            attrs={{
              theme: ButtonTheme.MarketingSecondary,
              href: `/pricing`,
              size: ButtonSize.Large,
            }}
          >
            View Pricing
          </ButtonEl>
          <ButtonEl
            attrs={{
              theme: ButtonTheme.MarketingPrimary,
              href: `/contact-us/sales`,
              size: ButtonSize.Large,
            }}
            on={{click: trackContactSalesClicked}}
          >
            Contact Sales
          </ButtonEl>
        </div>
      </div>
    </ModalEl>
  );
};
